import axios from 'axios';
import * as Sentry from '@sentry/react';
import { API_URL } from '../configs';
import { get, isArray, isString, map } from 'lodash';
import { authActions, getTokenFromStorage } from '../utils';

const createAxiosInstance = () => {
  const axiosInstance = axios.create({
    baseURL: API_URL,
    headers: {
      'Accept': 'application/json',
    },
  });

  axiosInstance.interceptors.request.use(
    async (config) => {
      const token = getTokenFromStorage();
      if (token) {
        try {
          const { data } = await axios.get(`${API_URL}/validate_token`, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          });
          if (!data) {
            throw new Error('Token is invalid');
          }
          config.headers['Authorization'] = `Bearer ${token}`;
        } catch (error) {
          authActions.resetLocalStorageAuthData();
          sessionStorage.clear();
          window.location.replace("/sign-in");
          throw error;
        }
      } else {
        window.location.replace("/sign-in");
        throw new Error('No token found');
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      Sentry.withScope((scope) => {
        if (error.response) {
          scope.setTag('status_code', get(error, 'response.status'));
          scope.setExtra('response', get(error, 'response.data.detail'));

          const detail = get(error, 'response.data.detail');
          let serverErrorMessage = 'Unknown server error';

          if (isArray(detail)) {
            const messages = map(detail, 'msg').join(', ');
            serverErrorMessage = messages || serverErrorMessage;
          } else if (isString(detail)) {
            serverErrorMessage = detail;
          } else {
            serverErrorMessage = JSON.stringify(detail);
          }

          Sentry.captureException(new Error(serverErrorMessage));
        } else {
          scope.setExtra('error', error);
          Sentry.captureException(error);
        }
      });
      return Promise.reject(error);
    }
  );
  return axiosInstance;
};

export default createAxiosInstance;